import { render, staticRenderFns } from "./QApage.vue?vue&type=template&id=267b1b0e"
import script from "./QApage.vue?vue&type=script&lang=ts"
export * from "./QApage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports